import type { KeycloakContext } from "@keycloak/keycloak-ui-shared";

export function getAccessToken(kc: KeycloakContext['keycloak']): () => Promise<string> {
    return async () => {
        try {
            await kc.updateToken();
        }
        catch {
            await kc.login();
        }
        return kc.token as string;
    }
}
